module.exports = __webpack_public_path__ + "img/banner-10-ja.1c9448fe.png";